enum RouteNames {
  CALLBACK = "/callback",
  AUTH = "/",
  ERROR = "/error",
  CONTRACTS = "/:activeTab",
  ADD_CONTRACT = "/add-contract",
  ADD_CONTRACT_FILE = "/add-contract-file",
  SUBMIT_TICKET = "/submit-ticket",
  UNAUTHORIZED = "/unauthorized",
  ADD_UNREGISTERED_CONTRACT = "/add-unregistered-contract",
}

export default RouteNames;
